export enum chartType {
    TotalSupplyChart,
    TotalConsumptionChart,
    NonRevenueWater,
    AssetSummary
}